import api from '../backAxios';

class MailingService {
    async verificarClienteMailing(queryParams) {
        try {
            const clienteMailing = await api.get(
                `/campanhas/mailing?${queryParams}`
            );

            return {
                status: clienteMailing.status,
                data: clienteMailing.data
            };
        } catch (error) {
            return {
                status:'error',
                errorMessage:error.message
            };
        }
    }
}

export default new MailingService();
